const normalizeRole = (role) =>
  String(role || "")
    .trim()
    .toLowerCase()
    .replace(/[_\s-]+/g, "");

export const isAdminOrOwnerRole = (role) => {
  const normalized = normalizeRole(role);
  return normalized === "admin" || normalized === "owner";
};

export const getKitOwnerId = (kit = {}) => {
  const raw =
    kit?.ownerUserId ||
    kit?.createdBy ||
    kit?.createdById ||
    kit?.userId ||
    null;
  return raw ? String(raw) : null;
};

export const getKitScope = (kit = {}) => {
  const rawScope =
    kit?.scope ||
    kit?.visibilityScope ||
    kit?.kitScope ||
    kit?.accessScope ||
    null;

  const scope = String(rawScope || "")
    .trim()
    .toLowerCase();

  if (scope === "company" || scope === "shared" || scope === "default") {
    return "company";
  }

  if (scope === "personal" || scope === "private" || scope === "user") {
    return "personal";
  }

  if (kit?.isDefault === true || kit?.isShared === true || kit?.sharedWithCompany === true) {
    return "company";
  }

  const creatorRole = normalizeRole(kit?.createdByRole);
  if (creatorRole === "admin" || creatorRole === "owner") {
    return "company";
  }

  if (!rawScope) {
    return "company";
  }

  return "personal";
};

export const canUserSeeKit = (kit = {}, userProfile = null) => {
  const myRole = normalizeRole(userProfile?.role);
  if (isAdminOrOwnerRole(myRole)) return true;

  if (getKitScope(kit) === "company") return true;

  const ownerId = getKitOwnerId(kit);
  const myId = userProfile?.uid || userProfile?.id || null;
  return !!ownerId && !!myId && String(ownerId) === String(myId);
};

export const canUserEditKit = (kit = {}, userProfile = null) => {
  const myRole = normalizeRole(userProfile?.role);
  if (isAdminOrOwnerRole(myRole)) return true;

  if (getKitScope(kit) === "company") return false;

  const ownerId = getKitOwnerId(kit);
  const myId = userProfile?.uid || userProfile?.id || null;
  return !!ownerId && !!myId && String(ownerId) === String(myId);
};

export const filterKitsForUser = (kits = [], userProfile = null) =>
  (Array.isArray(kits) ? kits : []).filter((kit) => canUserSeeKit(kit, userProfile));
